import { useState } from 'react';
import Button from './Button';
import BasicInput from './BasicInput';
import usePasscodeStore from '../stores/passcodeStore';

const PasscodeLock = () => {
  const [passcode, setPasscode] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const unlock = usePasscodeStore((state) => state.unlock);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    // Add a small delay to simulate processing
    await new Promise(resolve => setTimeout(resolve, 500));

    const success = unlock(passcode);
    
    if (!success) {
      setError('Invalid passcode. Please try again.');
      setPasscode('');
    }
    
    setIsLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full mx-4">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <div className="text-center mb-8">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
              </svg>
            </div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">Limited Access</h1>
            <p className="text-gray-600">This application is not released yet. Please enter the passcode to continue.</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="passcode" className="block text-sm font-medium text-gray-700 mb-2">
                Passcode
              </label>
              <BasicInput
                id="passcode"
                type="password"
                value={passcode}
                onChange={(e) => setPasscode(e.target.value)}
                placeholder="Enter passcode"
                containerClassName="w-full"
                error={error}
                disabled={isLoading}
                autoFocus
              />
            </div>

            <Button
              type="submit"
              className="w-full"
              disabled={!passcode.trim() || isLoading}
              isLoading={isLoading}
            >
              {isLoading ? 'Verifying...' : 'Unlock'}
            </Button>
          </form>

          <div className="mt-6 text-center">
            <p className="text-xs text-gray-500">
              Access restricted
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PasscodeLock;
